<app-basic-upscaling-simulator [config]="config"></app-basic-upscaling-simulator>
